var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    attrs: {
      "mode": "vertical",
      "collapse": _vm.isCollapse,
      "unique-opened": "",
      "default-active": _vm.$route.path,
      "background-color": "#324157",
      "text-color": "#bfcbd9",
      "active-text-color": "#20a0ff"
    }
  }, [_c('sidebar-item', {
    attrs: {
      "routes": _vm.itemRoute
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73272ee8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Sidebar.vue
// module id = 21i4
// module chunks = 49